import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Button } from '@/components/ui/button.jsx';
import { Mail, Settings, BarChart3, FileText, Building, Home } from 'lucide-react';
import './App.css';

import OrganizationPage from './pages/OrganiztionPage';
import TemplatePage from './pages/TemplatePage';
import CampaignPage from './pages/CampaignPage';
import MonitoringPageContainer from './pages/MonitoringPageConainer';
import SettingsPage from './pages/SettingsPage';
import DashboardPageContainer from './pages/DashboardPageContainer';

import LoginForm from '@/components/auth/LoginForm';
import { bootstrapAuth } from '@/lib/auth';

function App() {
  const [isAuthed, setIsAuthed] = useState(false);

  useEffect(() => {
    setIsAuthed(bootstrapAuth());
  }, []);

  const [activeTab, setActiveTab] = useState('dashboard');

  // Если не авторизован — показываем страницу логина
  if (!isAuthed) {
    return <LoginForm onSuccess={() => setIsAuthed(true)} />;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b p-4 flex items-center justify-between">
        <h1 className="text-2xl font-bold">FieldTurf Outreach</h1>
        <nav>
          <ul className="flex space-x-4">
            <li>
              <Button variant={activeTab === 'dashboard' ? 'secondary' : 'ghost'} onClick={() => setActiveTab('dashboard')}>
                <Home className="mr-2 h-4 w-4" /> Dashboard
              </Button>
            </li>
            <li>
              <Button variant={activeTab === 'campaigns' ? 'secondary' : 'ghost'} onClick={() => setActiveTab('campaigns')}>
                <Mail className="mr-2 h-4 w-4" /> Campaigns
              </Button>
            </li>
            <li>
              <Button variant={activeTab === 'organizations' ? 'secondary' : 'ghost'} onClick={() => setActiveTab('organizations')}>
                <Building className="mr-2 h-4 w-4" /> Organizations
              </Button>
            </li>
            <li>
              <Button variant={activeTab === 'templates' ? 'secondary' : 'ghost'} onClick={() => setActiveTab('templates')}>
                <FileText className="mr-2 h-4 w-4" /> Templates
              </Button>
            </li>
            <li>
              <Button variant={activeTab === 'monitoring' ? 'secondary' : 'ghost'} onClick={() => setActiveTab('monitoring')}>
                <BarChart3 className="mr-2 h-4 w-4" /> Monitoring
              </Button>
            </li>
            <li>
              <Button variant={activeTab === 'settings' ? 'secondary' : 'ghost'} onClick={() => setActiveTab('settings')}>
                <Settings className="mr-2 h-4 w-4" /> Settings
              </Button>
            </li>
          </ul>
        </nav>
      </header>

      <main className="flex-1 p-6">
        {activeTab === 'dashboard' && <DashboardPageContainer />}
        {activeTab === 'campaigns' && <CampaignPage />}
        {activeTab === 'organizations' && <OrganizationPage />}
        {activeTab === 'templates' && <TemplatePage />}
        {activeTab === 'monitoring' && <MonitoringPageContainer />}
        {activeTab === 'settings' && <SettingsPage />}
      </main>

      <footer className="border-t p-4 text-center text-sm text-muted-foreground">
        © 2025 FieldTurf Outreach. All rights reserved.
      </footer>
    </div>
  );
}

export default App;